import React from 'react';

import { Box, Typography } from '@mui/material';
import { WarningIcon } from 'app/shared/componentsRestyled/coreDesignSystem/icons';

import { AiChatTestIds } from '../../../../AiChat.testIds';
import { TOOL_CONFIRMATION_LABELS } from '../../ToolConfirmationCard.constants';
import {
  iconContainerStyles,
  iconStyles,
  statusContainerStyles,
  timedOutTextStyles,
} from '../../ToolConfirmationCard.styles';

const TimedOutStatus = () => (
  <Box sx={statusContainerStyles}>
    <Box sx={iconContainerStyles}>
      <WarningIcon size={18} style={iconStyles} />
    </Box>
    <Typography
      data-testid={AiChatTestIds.TOOL_CONFIRMATION_CARD_TIMED_OUT}
      sx={timedOutTextStyles}
      variant="regular12"
    >
      {TOOL_CONFIRMATION_LABELS.TIMED_OUT}
    </Typography>
  </Box>
);

export default TimedOutStatus;
